import { Directive, ViewContainerRef, Input, TemplateRef, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appTrimInput]'
})
export class TrimInputDirective {

  constructor(private el: ElementRef) {
  }

  @HostListener('blur', ['$event'])
  oninput(event) {
    this.el.nativeElement.value = this.el.nativeElement.value.trim();
  }

}
